import { app } from '../shared';

export const fetchCountryStats = async (findBody = {}) => {
  return app.service('countrystats').find(findBody);
};
